import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { OrganizationsService } from 'src/app/modules/organization/services/organizations.service'
import { environment } from 'src/environments/environment'
import { ClientService } from '../../services/client.service'
import { ActivatedRoute, Router } from '@angular/router'
import {
	clientProfileDetails,
	clientProfileTable,
} from 'src/app/modules/clients/models/client.model'
import { SharedService } from 'src/app/shared/services/shared.service'
import { ClientProfileStatus } from '../../models/client.enum'
import { AddSubtractFundPopupComponent } from 'src/app/modules/wallet/components/add-subtract-fund-popup/add-subtract-fund-popup.component'
import { MatDialog } from '@angular/material/dialog'
import {
	addSubtractPayloadModel,
	spWalletAmount,
	spWalletList,
} from '../../../wallet/models/wallet.models'
import { WalletService } from 'src/app/modules/wallet/services/wallet.service'
import { clientProfileList } from 'src/app/modules/payout/models/client-payout'
import { PayoutService } from 'src/app/modules/payout/services/payout.service'

@Component({
	selector: 'app-client-profile',
	templateUrl: './client-profile.component.html',
	styleUrls: ['./client-profile.component.scss'],
})
export class ClientProfileComponent implements OnInit {
	subscription = new Subscription()
	attachementUrl = environment.attachmentPath
	activeCountries!: any
	clientDetails!: clientProfileDetails
	selectedCountry: number = 224
	totalCount!: number
	totalWalletCount!: number
	payoutCount!: number
	tableData: clientProfileTable[] = []
	clientId: any

	clientBookingFilter: any = {
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},

		countryId: null,
		activeTab: 0,
		searchText: '',
	}

	clientPayoutFilter: any = {
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		payoutstatus: null,
		fromDate: '',
		toDate: '',
	}
	filterCount = 0
	payoutfilterCount = 0

	breadCrumbRout: any
	ClientProfileStatus = ClientProfileStatus
	ClientWalletData!: spWalletAmount
	walletData: spWalletList[] = []
	addSubtractDetails: addSubtractPayloadModel = {
		actorId: 0,
		currencyId: 0,
		amount: 0,
		reason: '',
		actor: 1,
	}
	payoutDataTable: clientProfileList[] = []
	isFliped = false
	pendingCount: any
	payoutFilterObject = []
	constructor(
		private organizationServ: OrganizationsService,
		public translate: TranslateService,
		private ClientServ: ClientService,
		private routeActivate: ActivatedRoute,
		private SharedService: SharedService,
		private router: Router,
		private dialog: MatDialog,
		private walletService: WalletService,
		private payoutService: PayoutService
	) {
		this.SharedService.headerTitle.next(`CLIENT.CLIENT_DETAILS.PAGE_TITLE`)
		this.SharedService.handleBreadCrumb('client-profile', false, {
			name: '',
			id: null,
			url: '',
			queryParams: null,
		})
	}

	ngOnInit(): void {
		this.getActiveCountries()

		this.routeActivate.params.subscribe(({ id }) => {
			this.clientId = id
			this.subscription.add(
				this.routeActivate.queryParams.subscribe((res) => {
					this.SharedService.handleBreadCrumb('client-profile', false, {
						name: '',
						id: this.clientId,
						url: '/layout/clients/client-profile',
						queryParams: null,
					})
					this.getProfileDetails(id)
					this.clientBookingFilter.activeTab = res['activeTab'] || 0
					this.clientBookingFilter.countryId = res['country'] || 224
					this.clientBookingFilter.paging.pageNumber = res['page'] || 1
					this.clientBookingFilter.paging.pageSize = res['count'] || 10
					this.getPendingCount()
					if (this.clientBookingFilter.activeTab == 0) {
						this.getClientWalletData(id)
						this.getWalletTransactionList()
					} else if (this.clientBookingFilter.activeTab == 1) {
						this.getPayoutList(
							this.payoutfilterCount != 0
								? this.payoutFilterObject
								: this.clientBookingFilter
						)
					} else if (this.clientBookingFilter.activeTab == 2) {
						this.getProfileTableData()
					}
				})
			)
		})
	}

	// get profile client data
	getProfileDetails(id: number) {
		this.subscription.add(
			this.ClientServ.getClientDetails(id).subscribe((res: any) => {
				this.clientDetails = res.result
				this.clientBookingFilter.clientId = this.clientDetails.id
			})
		)
	}
	//  get booking tab data

	getProfileTableData() {
		this.subscription.add(
			this.ClientServ.getClientProfileTableDetails(
				this.clientBookingFilter
			).subscribe((res: any) => {
				this.tableData = res.result.items
				this.totalCount = res.result.totalCount
			})
		)
	}
	// start  of wallet functions
	// get client total wallet data (first section)
	getClientWalletData(id: number) {
		this.subscription.add(
			this.ClientServ.getClientWalletData(
				this.clientId,
				this.clientBookingFilter.countryId
			).subscribe((res: any) => {
				this.ClientWalletData = res.result
			})
		)
	}
	// get wallet table tab data (second section)
	getWalletTransactionList(filter: any = null) {
		filter
			? (this.clientBookingFilter = { ...this.clientBookingFilter, ...filter })
			: null

		let body = {
			clientId: this.clientId,
			countryId: this.clientBookingFilter.countryId,
			...this.clientBookingFilter,
		}
		this.subscription.add(
			this.ClientServ.getWalletTransactionList(body).subscribe((res: any) => {
				this.walletData = res.result.items
				this.totalWalletCount = res.result.totalCount
			})
		)
	}
	// add & subtract actions
	addSubtractFund(image?: string, type?: string, currentAmount?: number) {
		this.dialog
			.open(AddSubtractFundPopupComponent, {
				width: '585px',
				data: {
					image: `assets/images/${image}`,
					type: type,
					currentAmount: type == 'sub' ? currentAmount : null,
					currency: this.clientBookingFilter.countryId,
				},
				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.addSubtractDetails.actorId = this.clientId
						this.addSubtractDetails.currencyId =
							this.clientBookingFilter.countryId
						this.addSubtractDetails = { ...this.addSubtractDetails, ...res }

						this.subscription.add(
							type == 'sub'
								? this.walletService
										.subtractFundFromWallet(this.addSubtractDetails)
										.subscribe((res) => {
											this.getWalletTransactionList()
											this.getClientWalletData(this.clientId)

											this.getClientWalletData(this.clientId)
											this.router.navigate([
												'/layout/clients/client-profile/' + this.clientId,
											])
										})
								: this.walletService
										.addFundToWallet(this.addSubtractDetails)
										.subscribe((res) => {
											this.getWalletTransactionList()
											this.getClientWalletData(this.clientId)

											this.getClientWalletData(this.clientId)
											this.router.navigate([
												'/layout/clients/client-profile/' + this.clientId,
											])
										})
						)
					}
				},
			})
	}
	// end of wallet functions
	// get payout tab data
	getPayoutList(filter: any = null) {
		filter
			? (this.clientBookingFilter = { ...this.clientBookingFilter, ...filter })
			: null
		filter
			? (this.payoutFilterObject = { ...this.clientBookingFilter, ...filter })
			: null

		let body = {
			clientId: this.clientId,
			countryId: this.clientBookingFilter.countryId,
			...filter,
		}
		this.subscription.add(
			this.payoutService.getClientProfilePayout(body).subscribe((res: any) => {
				this.payoutDataTable = res.result.items
				this.payoutCount = res.result.totalCount
			})
		)
	}
	getPendingCount() {
		const body = {
			clientId: this.clientId,
			countryId: this.clientBookingFilter.countryId,
			searchText: '',
		}
		this.subscription.add(
			this.payoutService
				.getClientProfilePendingPayoutCount(body)
				.subscribe((res: any) => {
					this.pendingCount = res.result
					let pending = this.ClientProfileStatus.find((val) => val.value == '1')
					pending
						? ((pending.count = this.pendingCount),
						  (pending.showCount = res.result ? true : false))
						: null
				})
		)
	}
	// shared functions to get page data
	getActiveCountries() {
		this.subscription.add(
			this.organizationServ.getActiveCountries().subscribe((res: any) => {
				this.activeCountries = res
			})
		)
	}
	tapChanged(event: any) {
		this.payoutFilterObject = []
		this.clientPayoutFilter = null
		this.payoutfilterCount = 0
		this.router.navigate(['/layout/clients/client-profile/' + this.clientId], {
			queryParams: {
				country: this.clientBookingFilter.countryId,
				activeTab: event,
			},
		})
	}
	pageChanged(pageNumber: number, pageCount: number) {
		this.router.navigate(['/layout/clients/client-profile/' + this.clientId], {
			queryParams: {
				country: this.clientBookingFilter.countryId,
				activeTab: this.clientBookingFilter.activeTab,
				page: pageNumber,
				count: pageCount,
			},
		})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
